import useHttpLoader from '@/shared/hooks/useHttpLoader'
import { IEquipment, IEquipmentDocument } from '../equipment.types'
import { useEffect, useState } from 'react'
import equipmentApi from '../equipment.api'
import config from '@/config'
import useAccessToken from '@/pages/Auth/hooks/useAccessToken'

const useEquipmentFiles = (equipmentId: IEquipment['id']) => {
  const token = useAccessToken()

  const { wait, loading } = useHttpLoader()
  const { wait: waitAction, loading: actionLoading } = useHttpLoader()

  const [documents, setDocuments] = useState<IEquipmentDocument[]>([])

  useEffect(() => {
    wait(equipmentApi.listEquipmentDocuments(equipmentId), (resp) => {
      if (resp.status === 'success') {
        setDocuments(resp.body.items)
      }
    })
  }, [equipmentId])

  const handleDocumentCreate = (file: File) => {
    return waitAction(equipmentApi.createEquipmentDocument(equipmentId, file), (resp) => {
      if (resp.status === 'success') {
        setDocuments((prev) => [...prev, resp.body])
      }
    })
  }

  const handleDocumentRemove = (id: IEquipmentDocument['id']) => {
    return waitAction(equipmentApi.deleteEquipmentDocument(id), (resp) => {
      if (resp.status === 'success') {
        setDocuments((prev) => [...prev].filter((doc) => doc.id !== id))
      }
    })
  }

  const handleDocumentUpdate = (id: IEquipmentDocument['id'], fileName: string) => {
    waitAction(equipmentApi.updateEquipmentDocument(id, { fileName }), (resp) => {
      if (resp.status === 'success') {
        setDocuments((prev) => {
          const index = prev.findIndex((it) => it.id === id)
          if (index === -1) return prev

          return [...prev.slice(0, index), ...prev.slice(index + 1)]
        })
      }
    })
  }

  const getDocumentUrl = (doc: IEquipmentDocument) => {
    return `${config.API_URL}/nsi/v1/equipment-documents/${doc?.id}/raw/${doc?.fileName}?accessToken=${token}`
  }

  return {
    data: {
      documents,
      dataLoading: loading,
      actionLoading,
    },
    handlers: {
      handleDocumentRemove,
      handleDocumentUpdate,
      handleDocumentCreate,
      getDocumentUrl,
    },
  }
}

export default useEquipmentFiles
